export default __webpack_public_path__ + "static/media/pouf8.30ba2e55.JPG";